module.exports = __webpack_public_path__ + "img/8.57b4155f.jpg";